export const colors = {
  'cadmiumRed': '#EB0A1E',
  'unitedNationsBlue': '#4A90E2',
  'menuWhite': '#f5f5f5',
};
